// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__14wVF","itemTitle":"ClientEmergencyInfo_itemTitle__2FKRj","itemText":"ClientEmergencyInfo_itemText__1Dm6F"};